<!-- user-form.component.html -->
<div class="form-container">
	<!-- כותרת קבועה -->
	<div class="form-header">
		<h1 class="form-title">{{ formTitle() | translate }}</h1>
	</div>
	@let userForm = userFormFactory.userForm;
	@let formSubmitting = formStatus() === 'submitting';

	<!-- אזור תוכן נגלל -->
	<div class="form-content dc-scrollbar">
		<!-- אינדיקציה לשינויים (אופציונלי) -->
		@if (isEditMode() && showChangesIndicator()) {
			<dc-form-changes-indicator [enabled]="showChangesIndicator()" />
		}

		<form
			#userFormElement
			[formGroup]="userForm"
			(ngSubmit)="onSubmit()"
			autoTabIndexTrap
		>
			<dc-accordion>
				@for (section of sections(); track section) {
					@switch (section) {
						<!-- Section 1: General Details -->
						@case ('GeneralDetails') {
							<dc-accordion-panel
								id="GeneralDetails"
								[initiallyExpanded]="true"
							>
								<div accordion-title>
									<h2 class="title">
										{{ 'user.form.section.general.label' | translate }}
									</h2>
								</div>
								<div accordion-indicator>
									<dc-user-form-section-validity-indicator section="GeneralDetails" />
								</div>

								<dc-user-form-general-details [parentForm]="userForm" />
							</dc-accordion-panel>
						}
						<!-- Section 2: Contact Information -->
						@case ('ContactInfo') {
							<dc-accordion-panel id="ContactInfo">
								<div accordion-title>
									<h2 class="title">
										{{ 'user.form.section.contact.label' | translate }}
									</h2>
								</div>
								<div accordion-indicator>
									<dc-user-form-section-validity-indicator section="ContactInfo" />
								</div>

								<dc-user-form-contact-information [parentForm]="userForm" />
							</dc-accordion-panel>
						}
						<!-- Section 3: Password Management -->
						@case ('Password') {
							<dc-accordion-panel id="Password">
								<div accordion-title>
									<h2 class="title">
										{{ 'user.form.section.password.label' | translate }}
									</h2>
								</div>
								<div accordion-indicator>
									<dc-user-form-section-validity-indicator section="Password" />
								</div>

								<dc-user-form-password [parentForm]="userForm" />
							</dc-accordion-panel>
						}
						<!-- Section 4: Permissions -->
						@case ('Permissions') {
							<dc-accordion-panel id="Permissions">
								<div accordion-title>
									<h2 class="title">
										{{ 'user.form.section.roles.label' | translate }}
									</h2>
								</div>
								<div accordion-indicator>
									<dc-user-form-section-validity-indicator section="Permissions" />
								</div>

								<dc-user-form-permissions [parentForm]="userForm" />
							</dc-accordion-panel>
						}

						<!-- Section 5: Active User Preferences -->
						@case ('ActiveUserPreferences') {
							<dc-accordion-panel id="ActiveUserPreferences">
								<div accordion-title>
									<h2 class="title">
										{{ 'user.form.section.active-user-preferences.label' | translate }}
									</h2>
								</div>
								<div accordion-indicator>
									<dc-user-form-section-validity-indicator section="ActiveUserPreferences" />
								</div>

								<dc-active-user-preferences [parentForm]="userForm" />
							</dc-accordion-panel>
						}
						@case ('ActiveUserStamps') {
							<dc-accordion-panel id="ActiveUserStamps">
								<div accordion-title>
									<h2 class="title">
										{{ 'user.form.section.active-user-stamps.label' | translate }}
									</h2>
								</div>
								<div accordion-indicator>
									<dc-user-form-section-validity-indicator section="ActiveUserStamps" />
								</div>

								@defer (on viewport) {
									<dc-active-user-stamps [parentForm]="userForm" />
								} @placeholder {
									<div>...</div>
								}
							</dc-accordion-panel>
						}
						@default {}
					}
				}
			</dc-accordion>
		</form>
	</div>

	<!-- כפתורים קבועים בתחתית -->
	<div class="form-footer">
		<!-- Global Form Error Message -->
		@defer (on interaction(userFormElement)) {
			@if (userForm.invalid && !formSubmitting) {
				<div class="global-error-message flex-1">
					<i class="fa-solid fa-circle-exclamation mr-2"></i>
					{{ 'user.form.validation.global-error-message' | translate }}
				</div>
			}
		} @placeholder {
			<div></div>
		}

		<button
			type="button"
			(click)="formCancel.emit()"
			class="cancel-button"
		>
			{{ formCancelButtonText() | translate }}
		</button>

		<button
			type="button"
			(click)="onSubmit()"
			class="submit-button"
			[disabled]="userForm.invalid || formSubmitting || (isEditMode() && !hasChanges())"
		>
			@if (!formSubmitting) {
				<span>
					{{ formSubmitButtonText() | translate }}
				</span>
			}
			@if (formSubmitting) {
				<span>
					<icon icon="fa-solid fa-spinner fa-spin mr-2"></icon>
					{{ formSubmitButtonText() | translate }}
				</span>
			}
		</button>
	</div>
</div>
